<script setup lang="ts">
import type { PropertySalePrices } from '@@/shared/property/types';

defineProps<{
  prices: PropertySalePrices
}>();

const { amount, perSurface, percentage } = useIadFormat();
</script>

<template>
  <div class="border border-neutral-70 p-m rounded-xl flex flex-col gap-s">
    <dl class="flex gap-m justify-between border-b border-neutral-70 pb-s">
      <IadTitle
        tag="dt"
        :text="$t(`property.price.sale.title`)"
        variant="x-small"
      />
      <IadTitle
        tag="dd"
        :text="amount(prices.main)"
        variant="x-small"
      />
    </dl>
    <p v-text="$t(`property.price.sale.of`)" />
    <dl class="flex gap-m justify-between">
      <dt v-text="$t(`property.price.per_surface.sale`)" />
      <dd v-text="perSurface(prices.perSurface)" />
    </dl>
    <p
      v-if="prices.feesCharge === `seller`"
      v-text="$t(`property.price.sale.fees_seller`)"
    />
    <template v-else>
      <dl class="flex gap-m justify-between">
        <dt v-text="$t(`property.price.sale.net`)" />
        <dd v-text="amount(prices.netPrice)" />
      </dl>
      <dl class="flex gap-m justify-between">
        <dt v-text="$t(`property.price.sale.fees_buyer`)" />
        <dd v-text="$t(`property.price.sale.fees_buyer_amount`, { amount: amount(prices.fees), percent: percentage(prices.feesRatio) })" />
      </dl>
    </template>
    <a
      href="/bareme_honoraires_iad.pdf"
      target="_blank"
      class="inline-flex items-center gap-2xs text-primary font-semibold"
    >
      {{ $t(`property.see_fees_scale`) }}
      <Icon name="iad-icon:arrow-forward" />
    </a>
  </div>
</template>
